export {default as SideBar} from "./Layout/SideBar"
export {default as MainSection} from "./Layout/MainSection"
export {default as SetPassword} from "./SetPassword"
export {default as TermsAndConditions} from "./TermsAndConditions"
